export const PERSIST_STATE_KEY = 'startup-craft'

export const UI_STATE = 'ui'

export const UI_ACTIONS = {
  UPDATE: `${UI_STATE}/update`,
}
